export const RESET_UPLOAD_LIST = "reset_upload_list";
export const CHANGE_UPLOAD_LIST_FIELD = "change_upload_list_field";
